import { ICreateProjetosChecklistUseCase } from "../../../presentation/useCases/create/create_projetos_checklist_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * CreateProjetosChecklistUseCase
 */

export class CreateProjetosChecklistUseCase implements ICreateProjetosChecklistUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async createProjetosChecklist(statusCheckList: boolean, nome: string, descricao: string): Promise<void> {
    await this.repository.createProjetosChecklist(statusCheckList,nome, descricao);
  }
}
